/* eslint-disable import/prefer-default-export */
import axios from 'axios'
import Cookies from 'js-cookie'
import AxiosInterceptor from '../hooks/AxiosInterceptorHook'
import {apiURLs, getWithCredentials, AddPDPCookie, getIPlanetProCookieName} from './Utility'

import { getCsrfToken as getStoredCsrfToken } from './csrfToken'

const csrfCookieNames = ['XSRF-TOKEN', 'CSRF-TOKEN', 'X-CSRF-TOKEN']

const getCsrfToken = () => {
  const storedToken = getStoredCsrfToken()
  if(storedToken) {
    return storedToken
  }
  for(let i = 0; i < csrfCookieNames.length; i += 1) {
    const token = Cookies.get(csrfCookieNames[i])
    if(token) {
      return token
    }
  }
  return null
}

const withCsrfHeader = (request = {}) => {
  const method = (request.method || 'GET').toUpperCase()
  if(!['POST', 'PUT', 'PATCH', 'DELETE'].includes(method)) {
    return request
  }

  const csrfToken = getCsrfToken()
  if(!csrfToken) {
    return Promise.reject(new Error('CSRF token not found. Unable to send request.'))
  }

  return {
    ...request,
    headers: {
      ...(request.headers || {}),
      'X-CSRF-Token': csrfToken,
      'X-XSRF-TOKEN': csrfToken
    }
  }
}



/**
 * Custome axios axiosInstance for usermanager api
 * @param {string} iPlanetDirectoryProCookie
 * @param {string} bearerToken
 */
// defaults for bearer token and planetprocookie are set in loginHook
// after call to logLogin
const createCompanyManagerAxiosInstance = () => {
  const axiosInstance = axios.create({
    baseURL: apiURLs.userManagerBaseUrl,
    headers: {
      'Content-Type': 'application/json'
    },
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    withCredentials: getWithCredentials()
  })

  AddPDPCookie(axiosInstance)
  axiosInstance.interceptors.request.use(withCsrfHeader)

  const interceptor = AxiosInterceptor(axiosInstance)

  return {axiosInstance, interceptor}
}

const companyManagerAxiosInstance = createCompanyManagerAxiosInstance()


export default {
  getUserCompanyRoles: companyId =>
    companyManagerAxiosInstance.axiosInstance({
      url: `/companies/${companyId}/roles`,
      method: 'GET'
    }),
  getCompanyRoles: companyId =>
    companyManagerAxiosInstance.axiosInstance({
      url: `/companies/${companyId}/companyroles`,
      method: 'GET'
    }),
  getApplicationRoles: applicationId =>
    companyManagerAxiosInstance.axiosInstance({
      url: 'companies/applicationroles',
      method: 'POST',
      data: {applicationId}
    }),
  getAvailableRoles: applicationId =>
    companyManagerAxiosInstance.axiosInstance({
      url: 'companies/availableroles',
      method: 'POST',
      data: {applicationId}
    }),
  getCompaniesList: applicationId =>
    companyManagerAxiosInstance.axiosInstance({
      url: '/companieslist',
      method: 'POST',
      data: {applicationId}
    }),
  getCompany: companyId =>
    companyManagerAxiosInstance.axiosInstance({
      url: `/companies/${companyId}`,
      method: 'GET'
    }),

  addOrUpdateCompany: (isAdd, company) => {
    const url = `/companies/company/${isAdd ? 'add' : 'update'}`

    return companyManagerAxiosInstance.axiosInstance({
      url,
      method: 'POST',
      data: company
    })
  },

  validateCompanyName: (company) => {
    const url = `/companies/company/validatecompanyname`

    return companyManagerAxiosInstance.axiosInstance({
      url,
      method: 'POST',
      data: company
    })
  },

  validateAlternateID: (company) => {
    const url = `/companies/company/validatealternateid`

    return companyManagerAxiosInstance.axiosInstance({
      url,
      method: 'POST',
      data: company
    })
  },
  getAlternateIds: () =>
    companyManagerAxiosInstance.axiosInstance({
      url: `/companies/alternateids`,
      method: 'GET'
    }),

  setJwtToken: jwtToken => {
    companyManagerAxiosInstance.axiosInstance.defaults.headers.common.Authorization = `Bearer ${jwtToken}`
  },
  setPDPCookie: iPlanetDirectoryProCookie => {
    companyManagerAxiosInstance.axiosInstance.defaults.headers[
      getIPlanetProCookieName()
    ] = iPlanetDirectoryProCookie
  },
  setRequestInterceptor: (interceptor) => {
    companyManagerAxiosInstance.interceptor.setRequestInterceptor(interceptor)
  },
  setResponseInterceptor: (interceptor) => {
    companyManagerAxiosInstance.interceptor.setResponseInterceptor(interceptor)
  },


}
